<form [formGroup]="firstFormGroup" *ngIf="muestraNormalizacion === true">
    <div class="form-row normalizador">
        <!-- <div class="col-lg-3 mb-0">
            <mat-form-field [formGroup]="firstFormGroup">
                <mat-label>Tipo de vía</mat-label>
                <select matNativeControl formControlName="tipoViaNormaliza">
                    <option *ngFor='let datos of datosTipoVia' value="{{datos.code}}">{{datos.code}}</option>
                </select>
                <mat-error *ngIf="errorHandling('tipoViaNormaliza', 'required')">
                    Campo obligatorio.
                </mat-error>
            </mat-form-field>
        </div> -->
        <div class="col-lg-10 mb-0">
            <mat-form-field [formGroup]="firstFormGroup">
                <mat-label>Nombre de la vía</mat-label>
                <input type="text" matInput matGoogleMapsAutocomplete name="nombreViaNormaliza" formControlName="nombreViaNormaliza" placeholder=""
                       [types]="['address']"
                       [country]="country"
                       (input)="onAddressChange($event)"
                       (focusin)="onAddressChange($event)"
                       (focusout)="onAddressFocusOut()"
                       (onAutocompleteSelected)="onAutocompleteSelected($event)"/>
                <!-- error -->
                <mat-error *ngIf="errorHandling('nombreViaNormaliza', 'required')">
                    Campo obligatorio.
                </mat-error>
            </mat-form-field>

            <div #manualAddress class="manual-address" (click)="formNumber.focus()">
                <strong #manualAddressText class="manual-address-text"></strong>
                <span class="manual-address-link">Continuar con selección manual</span>
            </div>
        </div>
        <div class="col-lg-2 mb-0">
            <mat-form-field [formGroup]="firstFormGroup">
                <mat-label>Número</mat-label>
                <input #formNumber matInput type="number" name="numeroNormaliza" formControlName="numeroNormaliza" pattern="\d+" min="0">
                <!-- error -->
                <mat-error *ngIf="errorHandling('numeroNormaliza', 'required')">
                    Campo obligatorio.
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <!--SEGUNDA FILA-->
    <div class="form-row normalizador">
        <div class="col-lg-3 mb-1">
            <mat-form-field [formGroup]="firstFormGroup">
                <mat-label>Código Postal</mat-label>
                <input matInput type="number" name="codigoPostalNormaliza" formControlName="codigoPostalNormaliza" (input)="onChangeZip($event.target.value)" pattern="\d+" min="0">
                <!-- error -->
                <mat-error *ngIf="errorHandling('codigoPostalNormaliza', 'required')">
                    Campo obligatorio.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-lg-5 mb-1">
            <mat-form-field [formGroup]="firstFormGroup">
                <mat-label>Localidad</mat-label>
                <input matInput type="text" name="localidadNormaliza" formControlName="localidadNormaliza">
                <!-- error -->
                <mat-error *ngIf="errorHandling('localidadNormaliza', 'required')">
                    Campo obligatorio.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-lg-4 mb-1">
            <mat-form-field [formGroup]="firstFormGroup">
                <mat-label>Provincia</mat-label>
                <select matNativeControl formControlName="provinciaNormaliza">
                    <option *ngFor="let datos of datosProvincia" value="{{datos.code}}">{{datos.code}}</option>
                </select>
                <!-- error -->
                <mat-error *ngIf="errorHandling('provinciaNormaliza', 'required')">
                    Campo obligatorio.
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <mat-error *ngIf="muestraErrorPeticion">
        <p class="alert alert-warning">
            {{msgErrorPeticion}}
        </p>
    </mat-error>
    <button id="submit" type="submit" [disabled]="isLoading" *ngIf="muestraBoton" class="btn btn-black-outline mb-1 spinner" (click)="onNormalizarDireccion()">
        <span *ngIf="isLoading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        {{textDefault}}
    </button>

</form>
